import { useTranslation } from '@shared/core';
import { Box, ButtonV2, DialogV2, Flex, TextV2, useDisclosure } from '@withjoy/joykit';
import { Help } from '@withjoy/joykit/icons';
import React from 'react';
import { ReactComponent as YouTube } from '@assets/icons/brand-youtube.svg';
import { ReactComponent as Vimeo } from '@assets/icons/brand-vimeo.svg';

export const VideoHelpDialog = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t2 } = useTranslation('websiteEditor');
  const translations = t2('customPage', 'video', 'helpDialog');

  return (
    <>
      <Box
        color={'mono8'}
        cursor={'pointer'}
        onClick={onOpen}
      >
        <Help size={'sm'} />
      </Box>
      <DialogV2
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        disableAutoFocus
        overrides={{
          Body: {
            props: {
              paddingX: 8,
              paddingY: 8,
            },
          },
        }}
      >
        <DialogV2.Body>
          <DialogV2.CloseButton />
          <Flex
            flexDirection="column"
            rowGap={8}
          >
            <Flex
              flexDirection="column"
              rowGap={6}
              textAlign="center"
              paddingX={8}
            >
              <TextV2 typographyVariant="hed6">{translations.title}</TextV2>
              <Flex
                columnGap={6}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <Vimeo />
                <YouTube />
              </Flex>
              <TextV2 typographyVariant="body1">{translations.description}</TextV2>
            </Flex>
            <ButtonV2
              intent="neutral"
              shape="rounded"
              onClick={onClose}
              fullWidth
            >
              {translations.cta}
            </ButtonV2>
          </Flex>
        </DialogV2.Body>
      </DialogV2>
    </>
  );
};
